import React, { useRef } from "react"
import instagramLogo from "core/file-gallery/instagram.png"
import { useCurrentUser } from "hooks/use-current-user"
import { get } from "lodash"
import Note from "@kit/design/note"

const Disclaimer = ({ note }) => {
  return <p style={{ margin: "24px 0", color: "#778" }}>{note}</p>
}

const InstagramDeprecationWarning = () => {
  return (
    <Note className="text-left mt-6">
      Instagram has changed the way we connect to your account. Additionally,
      they are only allowing Instagram business accounts to connect. Please
      reconnect to restore your integration.
    </Note>
  )
}

const authUrl = `https://www.instagram.com/oauth/authorize?enable_fb_login=0&force_authentication=1&client_id=${process.env.INSTAGRAM_CLIENT_ID_V2}&redirect_uri=${process.env.INSTAGRAM_REDIRECT_URI}&response_type=code&scope=instagram_business_basic%2Cinstagram_business_manage_messages`

export const ConnectToInstagram = ({ afterAuth, apiUpgradeFlag }) => {
  const user = useCurrentUser()
  const authWindow = useRef(null)
  const authWindowListener = useRef(null)
  const disclaimerNote = user.account_is_multi_user
    ? "Users of your account will have access to photos from your Instagram\naccount. You can disconnect at any time"
    : "Only you have access to photos from your Instagram account. You can\ndisconnect at any time."

  const handleAuth = () => {
    const options = {
      path: authUrl,
      windowName: "Connect your Instagram Account",
      windowOptions: "status=0,width=500,height=700,centerscreen"
    }

    authWindow.current = window.open(
      options.path,
      options.windowName,
      options.windowOptions
    )
    authWindowListener.current = setInterval(() => {
      if (authWindow.current.closed) {
        clearInterval(authWindowListener.current)
        analytics.track("Connected instagram account", {
          account_id: get(user.id, "user.account_id", "anonymous user")
        })
        afterAuth()
      }
    }, 1000)
  }

  return (
    <div
      style={{
        margin: "20px 0",
        padding: "20px",
        textAlign: "center",
        borderRadius: "4px",
        border: "solid thin #e3e3e3",
        backgroundColor: "white"
      }}
    >
      <h2
        style={{ marginBottom: "20px", fontWeight: "bold", fontSize: "28px" }}
      >
        Connect your Instagram account to display your photo feed
      </h2>
      <button
        onClick={handleAuth}
        className="bg-gray-300"
        style={{
          borderRadius: "4px",
          padding: "12px 24px"
        }}
      >
        <img
          src={instagramLogo}
          alt="Instagram logo"
          style={{
            display: "inline",
            width: "20px",
            marginRight: "12px",
            verticalAlign: "sub"
          }}
        />
        Log in with Instagram
      </button>
      {apiUpgradeFlag && <InstagramDeprecationWarning />}
      <Disclaimer note={disclaimerNote} />
    </div>
  )
}
